/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';

/**
 * Composable to manage parent/child relationships of macro-bubbles and avoid loops.
 * @param {Array} elements - Ref: List of elements (macro, task, milestone...)
 * @return {Object} - { getMacroParentsSet: function to get a Set of all parents of a macroId }
 */
export function useMacroParents(elements) {
  // elsParents: { [childId]: Set(parentId, ...) } - level 1 parents only
  const elsParents = computed(() => {
    const elsChildren = {};
    elements.value.forEach((el) => {
      if (! el.getSubTasks()) return; // take only el with children
      elsChildren[el.id] = el.getSubTasks();
    });

    const result = {};
    Object.keys(elsChildren).forEach((key) => {
      const parent = parseInt(key, 10);
      const children = elsChildren[key];

      children.forEach((child) => {
        if (! result[child]) result[child] = new Set();
        result[child].add(parent);
      });
    });
    return result;
  });

  // Recursive function to find all parents of a macroId, including macroId
  function getMacroParentsSet(macroId, macroParentsSet = new Set()) {
    if (macroParentsSet.has(macroId)) return null;
    macroParentsSet.add(macroId);

    const parentsIds = new Set(elsParents.value[macroId]);
    parentsIds.forEach((parentId) => {
      if (macroParentsSet.has(parentId)) return null;
      return getMacroParentsSet(parentId, macroParentsSet);
    });
    return macroParentsSet;
  }

  return {
    getMacroParentsSet,
  };
}
